<template>
  <BModal
    id="modal-success-topup"
    ref="modal-success-topup"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    size="md"
  >
    <div
      class="position-absolute"
      style="right: 15px; top: 15px;"
    >
      <feather-icon
        icon="XIcon"
        class="cursor-pointer"
        @click="closeModal"
      />
    </div>

    <div
      ref="receiptContent"
      class="receipt-content"
    >
      <BRow>
        <BCol
          cols="12"
          class="text-center"
        >
          <div class="canvas-container">
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/Checklist-fill.svg"
              alt="Check"
              width="24"
              height="24"
            >
            <h4 class="text-black font-weight-bold m-0 inline-block float-left">
              {{ source === 'topup' ? 'Top Up Berhasil' : 'Berhasil Langganan' }}
            </h4>
          </div>
        </BCol>
      </BRow>

      <BRow class="mt-2">
        <BCol class="d-flex justify-content-between">
          <h5 class="text-black font-weight-bold">
            Detail Transaksi
          </h5>
          <div class="d-flex align-items-center gap-[4px]">
            <img
              v-if="getPlatformIcon"
              :src="getPlatformIcon"
              :alt="transaction.platform_name"
              width="16"
              height="16"
            >
            <img
              v-if="transaction.ad_account_type === 'cpas'"
              src="https://storage.googleapis.com/komerce/komads-meta/shopee.svg"
              :alt="`${transaction.platform_name}-${transaction.ad_account_type}`"
              width="16"
              height="16"
            >
            <span class="text-black text-bold capitalize">{{ transaction.platform_name }} {{ transaction.ad_account_type }}</span>
          </div>
        </BCol>
      </BRow>
      <hr class="my-1">

      <!-- Detail Transaksi -->
      <BRow class="mt-2">
        <BCol cols="12">
          <div class="d-flex justify-content-between mb-2">
            <span class="text-secondary">Tanggal Topup</span>
            <span class="text-black">{{ formatDate(transaction.created_at) }}</span>
          </div>
          <div
            v-if="transaction.status === 'success'"
            class="d-flex justify-content-between mb-2"
          >
            <span class="text-secondary">Tanggal Diproses</span>
            <span class="text-black">{{ formatDate(transaction.updated_at) }}</span>
          </div>
          <div class="d-flex justify-content-between mb-2">
            <span class="text-secondary">Id Transaksi</span>
            <span class="text-black">{{ transaction.transaction_id }}</span>
          </div>
          <div class="d-flex justify-content-between mb-2">
            <span class="text-secondary">Email</span>
            <span class="text-black">{{ transaction.partner_email }}</span>
          </div>
          <template v-if="source === 'topup'">
            <div class="d-flex justify-content-between mb-2">
              <span class="text-secondary">Akun WL tujuan</span>
              <span class="text-black">{{ transaction.whitelist_account_name }}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span class="text-secondary">Nominal top up</span>
              <span class="text-black">{{ IDR(transaction.amount_topup) }}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span class="text-secondary">Top up fee ({{ transaction.fee_topup }}%)</span>
              <span class="text-black" />
            </div>
            <hr class="my-1">
            <div class="d-flex justify-content-between mb-2">
              <span class="text-secondary">• Fee</span>
              <span class="text-black">{{ IDR(transaction.amount_fee) }}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span class="text-secondary">• PPN</span>
              <span class="text-black">{{ IDR(transaction.amount_tax) }}</span>
            </div>
            <hr class="mb-2">
            <div class="d-flex justify-content-between">
              <span class="text-black font-weight-bold">Total dibayarkan</span>
              <span class="text-black font-weight-bold">{{
                IDR(transaction.amount_total)
              }}</span>
            </div>
          </template>
          <template v-else-if="source === 'subscription'">
            <div class="d-flex justify-content-between mb-2">
              <span class="text-secondary">Masa Berlaku</span>
              <span class="text-black">{{ DDMMMMYYYY(transaction.subscription_data.created_at) }} - {{ DDMMMMYYYY(transaction.subscription_data.expired_at) }}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span class="text-secondary">Nominal</span>
              <span class="text-black">{{ IDR(transaction.subscription_data.nominal) }}</span>
            </div>
          </template>
        </BCol>
      </BRow>
    </div>

    <!-- Action Buttons -->
    <div class="my-2 flex gap-4">
      <BButton
        class="w-full"
        variant="primary"
        @click="closeModal"
      >
        Tutup
      </BButton>
    </div>
  </BModal>
</template>

<script>
import moment from 'moment'
import { DDMMMMYYYY } from '@/libs/filterDate'
import { IDR } from '@/libs/currency'

export default {
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    source: {
      type: String,
      default: 'topup',
    },
  },
  data() {
    return {
      IDR,
      DDMMMMYYYY,
    }
  },
  computed: {
    getPlatformIcon() {
      const platformIcons = {
        meta: 'https://storage.googleapis.com/komerce/komads-meta/meta.svg',
        google: 'https://storage.googleapis.com/komerce/komads-meta/google.svg',
        tiktok: 'https://storage.googleapis.com/komerce/komads-meta/tiktok.svg',
      }

      // Handle different platform name formats from API
      const platformName = this.transaction.platform_name?.toLowerCase()

      return platformIcons[platformName] || ''
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD MMMM YYYY | HH:mm [WIB]')
    },
    /**
     * Close the modal
     */
    closeModal() {
      this.$refs['modal-success-topup'].hide()
    },
  },
}
</script>

<style lang="css" scoped>
.cursor-pointer {
  cursor: pointer;
}

.receipt-content {
  padding: 16px;
  background-color: #ffffff;
}
.canvas-container {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}
/* Responsive styles */
@media (max-width: 576px) {
  .modal-dialog {
    margin: 0.5rem;
  }
}
</style>
